import { notification } from 'antd';
import axios from 'axios';
import Cookies from 'js-cookie';
import { getItem, removeItem } from '../../utility/localStorageControl';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const authHeader = () => ({
  Authorization: `Bearer ${getItem('access_token')}`,
});

const client = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    Authorization: `Bearer ${getItem('access_token')}`,
    'Content-Type': 'application/json',
    // Removed 'Content-Type' to avoid issues with file downloads
  },
});

class DataService {
  static get(path = '', params = {}, responseType = 'json') {
    return client({
      method: 'GET',
      url: path,
      headers: { ...authHeader() },
      params,
      responseType,
    });
  }

  static post(path = '', data = {}, optionalHeader = {}, responseType = 'json') {
    return client({
      method: 'POST',
      url: path,
      data,
      headers: { ...authHeader(), ...optionalHeader },
      responseType,
    });
  }

  static patch(path = '', data = {}, responseType = 'json') {
    return client({
      method: 'PATCH',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
      responseType,
    });
  }

  static delete(path = '', data = {}, responseType = 'json') {
    return client({
      method: 'DELETE',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
      responseType,
    });
  }

  static put(path = '', data = {}, responseType = 'json') {
    return client({
      method: 'PUT',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
      responseType,
    });
  }
}

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */
client.interceptors.request.use((config) => {
  // do something before executing the request
  // For example tag along the bearer access token to request header or set a cookie
  const requestConfig = config;
  const { headers } = config;
  requestConfig.headers = { ...headers, Authorization: `Bearer ${getItem('access_token')}` };

  return requestConfig;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    /**
     * Do something in case the response returns an error code [3**, 4**, 5**] etc
     * For example, on token expiration retrieve a new access token, retry a failed request etc
     */
    const { response } = error;
    // const originalRequest = error.config;
    if (response) {
      if (response.status === 401) {
        removeItem('access_token');
        removeItem('user');

        Cookies.remove('logedIn');

        window.location.href = '/';
      } else if (response.status === 403) {
        notification.error({
          message: 'Anda tidak bisa mengakses data ini !',
        });
      } else if (response.status === 404) {
        return Promise.reject(error);
      } else if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          Object.keys(response.data.errors[key]).forEach(function (message) {
            notification.error({
              message: response.data.errors[key][message],
            });
          });
        });
      } else if (response.status === 500) {
        notification.error({
          message: response.data.message || 'Terjadi kesalahan pada server !',
        });
        return Promise.reject(error);
      } else {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  },
);
export { DataService };
